export default __webpack_public_path__ + "static/media/1.218fbae3.png";